// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function currentCourseRule(member: any, base: string) {
  let currentCourse: string =
    member?.education?.currentCourse.answer ?? 'não informado'
  if (currentCourse === 'não informado' && base === 'agents') currentCourse = ''

  if (member.age < 8 && member.age > 0) {
    if (
      (base === 'agents' && currentCourse.startsWith('Não')) ||
      (base === 'cadunico' && currentCourse === 'não informado')
    ) {
      return true
    } else return false
  } else return false
}
